import React, { Component } from "react";
import * as PropTypes from "prop-types";
import "./visWidgetConfig.css";
// import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
// import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { Chart } from "react-google-charts";

import DataForChart from "./googleDataWrapper";
class exampleChartA extends Component {
  constructor(props) {
    super(props);
    this.tableData = props.tableData;
  }

  state = {
    bodyOpacity: 1.0
  };

  componentDidMount() {
    // console.log('GizMOGraph component did mount ');
    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();
  }

  componentDidUpdate = (prevProps, prevState) => {};
  // if (prevProps.tableData!==this.props.tableData)

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions = () => {
    // const parentDiv = document.getElementById('configWidget');
    // const height = parentDiv.getBoundingClientRect().height;
    // const offset = 40;
    // this.setState({ bodyHeight: height - offset });
  };

  getData = () => {
    // console.log(' do we have TableData? ' + !!this.tableData);
    // console.log(this.tableData);
    // // make the wrapper for google data thingy;

    // reorganize the data;
    const headerArray = this.tableData.header;
    const unitArray = this.tableData.units;
    const valueArray = [];

    // deepCopy;
    for (let x = 0; x < this.tableData.values.length; x++) {
      valueArray[x] = [];
      for (let y = 0; y < this.tableData.values[x].length; y++) {
        valueArray[x][y] = this.tableData.values[x][y];
      }
    }

    // valueArray = this.transpose(valueArray); // need it for iterating for the googleWrapper
    // console.log(valueArray);

    console.log(headerArray);
    console.log(unitArray);

    // create index selectors;
    const valueSelector = [2, 5];

    // reshape the value array;

    let reshapedValueArray = [];
    valueSelector.forEach(index => {
      reshapedValueArray.push(valueArray[index]);
      console.log("Its unit is " + unitArray[index]);
    });

    console.log(reshapedValueArray);

    // now we can easyly generate the table data for the char api;
    const tableData = new DataForChart();

    tableData.addColumn("date", "Study date");
    tableData.addColumn("number", "R0 Estimate");

    // do this using the semantics of the units;
    // for (let i = 0; i < headerArray.length; i++) {
    //   if (unitArray[i] === "<<ANCHOR>>") {
    //     tableData.addColumn("string", headerArray[i]);
    //   }
    //
    //   if (unitArray[i] === "LocationName") {
    //     tableData.addColumn("string", headerArray[i]);
    //   }
    //
    //   // using strings for now;
    //   if (unitArray[i] === "Date") {
    //     tableData.addColumn("date", headerArray[i]);
    //   }
    //   if (unitArray[i] === "Description") {
    //     tableData.addColumn("string", headerArray[i]);
    //   }
    //
    //   if (unitArray[i] === "Numerical Range") {
    //     tableData.addColumn("string", headerArray[i]);
    //   }
    //   if (unitArray[i] === "Number") {
    //     tableData.addColumn("string", headerArray[i]);
    //   }
    // }

    // headerArray.forEach(item => {
    //   if (item === "Method") {
    //     tableData.addColumn("string", item);
    //   } else {
    //     // hard set for duration
    //     if (item === "Duration") {
    //       console.log("WE have found the Duration Entry! ");
    //       tableData.addColumn("string", item);
    //     } else {
    //       tableData.addColumn("number", item);
    //     }
    //   }
    // });

    // process the valueArray for the correct unit alignment;

    const monthMap = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11
    };

    for (let i = 0; i < reshapedValueArray.length; i++) {
      const indexInOrig = valueSelector[i];
      if (unitArray[indexInOrig] === "Date") {
        // transform it to date;
        for (let j = 0; j < reshapedValueArray[i].length; j++) {
          // fetch the value;

          const dataEntry = reshapedValueArray[i][j];
          let s_day, s_month, s_year;
          let n_day, n_month, n_year;

          if (dataEntry.indexOf("--") !== -1) {
            // this is the stupid thing;
            const tokens = dataEntry.split(" -- ");
            const pointInTime = tokens[1];
            console.log(pointInTime);

            const tokensTime = pointInTime.split(" ");
            s_day = tokensTime[0];
            s_month = tokensTime[1];
            s_year = tokensTime[2];

            n_day = parseInt(s_day);
            n_month = parseInt(monthMap[s_month]);
            n_year = parseInt(s_year);
          } else if (dataEntry.indexOf("and") !== -1) {
            // this is the stupid thing;
            const tokens = dataEntry.split(" and ");
            const pointInTime = tokens[1];
            console.log(pointInTime);

            const tokensTime = pointInTime.split(" ");
            s_day = tokensTime[0];
            s_month = tokensTime[1];
            s_year = tokensTime[2];

            n_day = parseInt(s_day);
            n_month = parseInt(monthMap[s_month]);
            n_year = parseInt(s_year);
          } else {
            const tokensTime = dataEntry.split(" ");
            s_day = tokensTime[0];
            s_month = tokensTime[1];
            s_year = tokensTime[2];

            n_day = parseInt(s_day);
            n_month = parseInt(monthMap[s_month]);
            n_year = parseInt(s_year);
          }
          //console.log(n_day, +" " + n_month + " " + n_year);
          // create data;
          const asDate = new Date(n_year, n_month, n_day);
          reshapedValueArray[i][j] = asDate;
        }
      }
      if (unitArray[indexInOrig] === "Number") {
        for (let j = 0; j < reshapedValueArray[i].length; j++) {
          if (reshapedValueArray[i][j].indexOf("--") !== -1) {
            // split it
            const meanValue = reshapedValueArray[i][j]
              .split(" -- ")[1]
              .split(" ")[1];
            // remove the ()
            const thatValue = meanValue.substring(1, meanValue.length - 1);
            reshapedValueArray[i][j] = parseFloat(thatValue);
          } else {
            reshapedValueArray[i][j] = parseFloat(reshapedValueArray[i][j]);
          }
          console.log(reshapedValueArray[i][j]);
        }
      }
    }

    reshapedValueArray = this.transpose(reshapedValueArray);
    // process the timeline stuff;

    reshapedValueArray.forEach(row => {
      console.log(row);
      tableData.addRow(...row);
    });

    console.log(this.tableData.values);
    return tableData.getChartData();
  };

  transpose = m => m[0].map((x, i) => m.map(x => x[i]));

  createChartObject() {
    return (
      <Chart
        chartType="ScatterChart"
        data={this.getData()}
        width="100%"
        height="100%"
        options={{ showRowNumber: true }}
      />
    );
  }

  /** Component Rendering Function **/
  render() {
    const chartObject = this.createChartObject();
    return (
      <div
        id="chartWidget"
        style={{
          width: "94%",
          height: "600px",
          marginBottom: "30px",
          paddingLeft: "2.5%"
        }}
      >
        <div id="chartWidgetHeader" className={"headerStyle"}>
          Scatter Plot
        </div>
        <div
          id="chartWidgetBody"
          className={"bodyStyle"}
          style={{
            height: this.state.bodyHeight,
            opacity: this.state.bodyOpacity
          }}
        >
          {chartObject}
        </div>
      </div>
    );
  }
}
exampleChartA.propTypes = {
  tableData: PropTypes.any.isRequired
};
export default exampleChartA;
